import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export class SportLiveMatchesListener extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT;
    }
    getOutcomeData(cfg) {
        return Object.assign({ timezone: this.timezone, site: this.siteType, lng: this.language }, cfg);
    }
}
export class SportLiveMatchesMobileListener extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT_MOBILE;
    }
    getOutcomeData(cfg) {
        return Object.assign({ timezone: this.timezone, site: this.siteType, lng: this.language }, cfg);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/matches/live/Sport.js